import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { combineForms } from 'react-redux-form';
import counterReducer from '../features/counter/counterSlice';
import * as Translation from '../app/store/external/translation-reducer/translation.reducer';
import * as authenticationReducer from '../app/store/user-login.reducer';
import { reducer as oidcReducer } from 'redux-oidc';
//external
import * as NavMenu from '../app/store/external/nav-menu-reducer/nav-menu.reducer';

//external - common
import * as fileAttachmentReducer from '../app/store/external/common-reducer/file-attachment.reducer';
//external - request
import * as requestLogReducer from '../app/store/external/request-reducer/request-log.reducer';
import * as requestDetailReducer from '../app/store/external/request-reducer/request-details.reducer';
import * as SideNavMenu from '../app/store/external/side-nav-menu-reducer/side-nav-menu.reducer';
import * as CircuitUsage from '../app/store/external/circuit-usage-reducer/circuit-usage.reducer'
import * as createRequestReducer from '../app/store/external/request-reducer/create-request.reducer';
//external - request - wireless
import * as newMobileSubscriptionReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer';
import * as wirelessChangeVendorReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-vendor.reducer';
import * as wirelessChangeUserReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-user.reducer';
import * as wirelessChangePricePlanReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-price-plan.reducer';
import * as wirelessOtherReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-other.reducer';
import * as wirelessPortInReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer';
import * as wirelessPortOutReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-portout.reducer';
import * as wirelessReplaceDeviceReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-device.reducer';
import * as wirelessReplaceSimReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-sim.reducer';
import * as wirelessTerminateReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-terminate-subscription.reducer';
import * as wirelessAccessoryReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-accessory.reducer';
import * as wirelessIntlRoamingAccessReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-intl-roaming-access.reducer';
//external - request - wireline
import * as wirelineChangeVendorReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-change-vendor.reducer';
import * as wirelineUpgradeCircuitReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-upgrade-circuit.reducer';
import * as wirelineTerminateCircuitReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate-circuit.reducer';
import * as wirelineTerminateExhibitBReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate/wireline-terminate-exhibit-b.reducer';
import * as wirelineOtherRequestReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-other-request.reducer';
import * as newCircuitSubscriptionReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer';
import * as newCircuitExhibitBReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-exhibit-b.reducer';
import * as newQuotationReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer';
//external - release notes
import * as releaseNotesReducer from './store/external/release-notes-reducer/release-notes-reducer'

import * as csatSurveyReducer from './store/external/csat-survey-reducer/csat-survey.reducer';
import * as inventoryCircuitReducer from './store/external/inventory/circuit.reducer';
import * as inventoryASRReducer from './store/external/inventory/asr.reducer';
import * as inventoryASPUReducer from './store/external/inventory/aspu.reducer';
import * as inventoryEquipmentReducer from './store/external/inventory/equipment.reducer';
import * as inventoryOrderHistoryReducer from './store/external/inventory/history/order-history.reducer';
import * as inventoryCostAllocationReducer from './store/external/inventory/add-cost-allocation.reducer';
import * as inventoryUsageSpendReducer from './store/external/inventory/usagespend.reducer';

import * as inventoryCircuitHistoryReducer from './store/external/inventory/history/circuit-history.reducer';
import * as inventoryEquipmentHistoryReducer from './store/external/inventory/history/equipment-history.reducer';
import * as inventoryCircuitSIMReducer from './store/external/inventory/details-view/add-sim.reducer';
import * as inventoryCircuitEquipReducer from './store/external/reports-reducer/inventory/details-view/add-equipment.reducer';
import * as inventoryLinkedCircuitReducer from './store/external/inventory-reducer/linked-circuits.reducer';
import * as inventoryCircuitAccessInformationReducer from './store/external/inventory/details-view/access-information.reducer';
import * as inventoryCircuitPIPInformationReducer from './store/external/inventory/details-view/pip-information.reducer';
import * as inventoryCircuitPlanDetailsReducer from './store/external/inventory/details-view/add-plan-details.reducer';
import * as inventoryCircuitInvoiceReducer from './store/external/inventory/invoice/invoice.reducer';

import * as invoiceDisputeDetailseReducer from './store/external/invoice/dispute/dispute-details.reducer';
import * as invoiceDisputeCommentsReducer from './store/external/invoice/dispute/dispute-comments.reducer';
import * as invoiceDisputeHistoryReducer from './store/external/invoice/dispute/dispute-history.reducer';

import * as invoiceDisputeReducer from './store/external/invoice/dispute.reducer';

import * as invoiceDisputeFollowUpReducer from './store/external/invoice/dispute/dispute-followup.reducer';

import * as invoiceUploadReducer from './store/external/invoice/invoice-upload/invoice-upload.reducer';
import * as chargeMappingReducer from './store/external/invoice/invoice-upload/charge-mapping.reducer';

import * as invoiceInvoiceReducer from './store/external/invoice/invoice.reducer';
import * as invoiceInvoiceDetailsReducer from './store/external/invoice/invoice/invoice-details.reducer';
import * as invoiceLineItemsReducer from './store/external/invoice/invoice/line-items.reducer';
import * as invoiceAuditRulesReducer from './store/external/invoice/invoice/audit-table.reducer';
import * as invoiceCommentReducer from './store/external/invoice/invoice/invoice-comments.reducer'
import * as invoiceHistoryReducer from './store/external/invoice/invoice/invoice-history.reducer';
import * as invoiceAuditReducer from './store/external/invoice/invoice/invoice-audit.reducer'

import * as adminSettingReducer from './store/admin-setting.reducer';

import * as invoiceSubLineReducer from './store/external/invoice/subline-item.reducer';

import * as notificationReducer from './store/common/header-navigation/header/notification.reducer';
import * as filterReducer from './store/external/filter-reducer/filter-reducer';

const rootReducer = combineReducers({
    routing: routerReducer
    , counter: counterReducer
    , adminSetting: adminSettingReducer.reducer
    , authentication: authenticationReducer.reducer
    , oidc: oidcReducer
    //external - request
    , requestLog: requestLogReducer.reducer
    , requestDetail: requestDetailReducer.reducer
    , translation: Translation.reducer

    //external:home
    , navMenu: NavMenu.reducer
    , sideNavMenu: SideNavMenu.reducer

    //external:common
    , fileAttachment: fileAttachmentReducer.reducer
    , releaseNotes: releaseNotesReducer.reducer
    , filter: filterReducer.reducer
    //external:request
    , circuitUsage: CircuitUsage.reducer
    , createRequest: createRequestReducer.reducer
    //external:request - wireless
    , newMobileRequest: newMobileSubscriptionReducer.reducer
    , wirelessChangeVendorRequest: wirelessChangeVendorReducer.reducer
    , wirelessChangeUserRequest: wirelessChangeUserReducer.reducer
    , wirelessChangePricePlanRequest: wirelessChangePricePlanReducer.reducer
    , wirelessOtherRequest: wirelessOtherReducer.reducer
    , wirelessPortOutRequest: wirelessPortOutReducer.reducer
    , wirelessPortInRequest: wirelessPortInReducer.reducer
    , wirelessReplaceDeviceRequest: wirelessReplaceDeviceReducer.reducer
    , wirelessReplaceSimRequest: wirelessReplaceSimReducer.reducer
    , wirelessTerminateRequest: wirelessTerminateReducer.reducer
    , wirelessAccessoryRequest: wirelessAccessoryReducer.reducer
    , wirelessIntlRoamingAccessRequest: wirelessIntlRoamingAccessReducer.reducer
    //external:request - wireline
    , wirelineChangeVendorRequest: wirelineChangeVendorReducer.reducer
        //terminate
    , wirelineTerminateCircuitRequest: wirelineTerminateCircuitReducer.reducer
    , wirelineTerminateExhibitBRequest: wirelineTerminateExhibitBReducer.reducer
        //upgrade
    , wirelineUpgradeCircuitRequest: wirelineUpgradeCircuitReducer.reducer
        //other
    , wirelineOtherRequestRequest: wirelineOtherRequestReducer.reducer
        //new circuit
    , newCircuitRequest: newCircuitSubscriptionReducer.reducer
    , newCircuitExhibitBRequest: newCircuitExhibitBReducer.reducer
        //quotation
    , quotationRequest: newQuotationReducer.reducer
    //END external:request - wireline

    , csatSurveyRequest: csatSurveyReducer.reducer

    // inventory tab
    , inventoryCircuit: inventoryCircuitReducer.reducer
    , inventoryEquipment: inventoryEquipmentReducer.reducer
    , inventoryASPU: inventoryASPUReducer.reducer
    , inventoryASR: inventoryASRReducer.reducer
    , inventoryOrderHistory: inventoryOrderHistoryReducer.reducer
    , inventoryUsageSpend: inventoryUsageSpendReducer.reducer

    , inventoryCircuitHistory: inventoryCircuitHistoryReducer.reducer
    , inventoryEquipmentHistory: inventoryEquipmentHistoryReducer.reducer
    , inventoryCircuitSIM: inventoryCircuitSIMReducer.reducer
    , inventoryCircuitEquip: inventoryCircuitEquipReducer.reducer
    , inventoryCostAllocation: inventoryCostAllocationReducer.reducer
    , inventoryLinkedCircuit: inventoryLinkedCircuitReducer.reducer
    , inventoryCircuitAccessInformation: inventoryCircuitAccessInformationReducer.reducer
    , inventoryCircuitPIPInformation: inventoryCircuitPIPInformationReducer.reducer
    , inventoryCircuitPlanDetails: inventoryCircuitPlanDetailsReducer.reducer

    , inventoryCircuitInvoice: inventoryCircuitInvoiceReducer.reducer

    // invoice tab
    , invoiceInvoice: invoiceInvoiceReducer.reducer
    , invoiceInvoiceDetails: invoiceInvoiceDetailsReducer.reducer
    , invoiceLineItems: invoiceLineItemsReducer.reducer
    , invoiceAuditRules: invoiceAuditRulesReducer.reducer
    , invoiceInvoiceComments: invoiceCommentReducer.reducer
    , invoiceInvoiceAudit: invoiceAuditReducer.reducer
    , invoiceUpload: invoiceUploadReducer.reducer
    , chargeMappingUpload: chargeMappingReducer.reducer

    , invoiceDispute: invoiceDisputeReducer.reducer
    , invoiceDisputeDetails: invoiceDisputeDetailseReducer.reducer
    , invoiceDisputeComments: invoiceDisputeCommentsReducer.reducer
    , invoiceDisputeFollowUpDetails: invoiceDisputeFollowUpReducer.reducer
    , invoiceDisputeHistory: invoiceDisputeHistoryReducer.reducer
    , invoiceSubLine: invoiceSubLineReducer.reducer

    , invoiceHistory: invoiceHistoryReducer.reducer

    , notification: notificationReducer.reducer
    //forms
    , form: combineForms({
        // WIRELESS
        // new mobile request
        wirelessLocationFormA: newMobileSubscriptionReducer.locationModelAInitialState
        , wirelessSubscriptionFormA: newMobileSubscriptionReducer.subscriptionModelAInitialState
        , wirelessBusinessFormA: newMobileSubscriptionReducer.businessModelAInitialState
        // port in
        , wirelessPortInLocationFormA: wirelessPortInReducer.portInLocationModelAInitialState
        , wirelessPortInSubscriptionFormA: wirelessPortInReducer.portInSubscriptionModelAInitialState
        , wirelessPortInBusinessFormA: wirelessPortInReducer.portInBusinessModelAInitialState
        //  change vendor
        , wirelessChangeVendorFormA: wirelessChangeVendorReducer.changeVendorModelAInitialState
        //  change price plan
        , wirelessChangePricePlanFormA: wirelessChangePricePlanReducer.changePricePlanModelAInitialState
        //  change user
        , wirelessChangeUserFormA: wirelessChangeUserReducer.changeUserModelAInitialState
        //  other
        , wirelessOtherFormA: wirelessOtherReducer.otherModelAInitialState
        //  port-out
        , wirelessPortOutFormA: wirelessPortOutReducer.portOutModelAInitialState
        //  replace device
        , wirelessReplaceDeviceFormA: wirelessReplaceDeviceReducer.replaceDeviceModelAInitialState
        //  replace sim
        , wirelessReplaceSimFormA: wirelessReplaceSimReducer.repalceSimModelAInitialState
        //  terminate
        , wirelessTerminateFormA: wirelessTerminateReducer.terminateModelAInitialState
        // accessory
        , wirelessAccessoryForm: wirelessAccessoryReducer.accessoryModelInitialState
        // international roaming access
        , wirelessIntlRoamingAccessForm: wirelessIntlRoamingAccessReducer.intlRoamingAccessModelInitialState        
        // END WIRELESS

        // WIRELINE
        //new circuit
        , wirelineLocationFormA: newCircuitSubscriptionReducer.wirelineLocationModelAInitialState
        , wirelineSubscriptionFormA: newCircuitSubscriptionReducer.wirelineSubscriptionModelAInitialState
        , wirelineBusinessFormA: newCircuitSubscriptionReducer.wirelineBusinessModelAInitialState
        // new circuit exhibit b
        , wirelineLocationFormB: newCircuitExhibitBReducer.wirelineLocationModelBInitialState
        , wirelineSubscriptionFormB: newCircuitExhibitBReducer.wirelineSubscriptionModelBInitialState
        , wirelineBusinessFormB: newCircuitExhibitBReducer.wirelineBusinessModelBInitialState
        // quotation
        , quotationLocationFormA: newQuotationReducer.quotationLocationModelAInitialState
        , quotationSubscriptionFormA: newQuotationReducer.quotationSubscriptionModelAInitialState
        , quotationBusinessFormA: newQuotationReducer.quotationBusinessModelAInitialState
        //  change vendor
        , wirelineChangeVendorFormA: wirelineChangeVendorReducer.changeVendorModelAInitialState
        //  upgrade circuit
        , wirelineUpgradeCircuitFormA: wirelineUpgradeCircuitReducer.upgradeCircuitModelA
        //  terminate
        , wirelineTerminateCircuitFormA: wirelineTerminateCircuitReducer.terminateCircuitModelAInitialState
        , wirelineTerminateCircuitFormB: wirelineTerminateExhibitBReducer.terminateCircuitModelBInitialState
        //  other request
        , wirelineOtherRequestFormA: wirelineOtherRequestReducer.otherRequestModelAInitialState
        // END WIRELINE

        // INVENTORY
        , inventoryCircuitForm: {
            circuitDetails: inventoryCircuitReducer.circuitDetailsFormInitialState,
            location1: inventoryCircuitReducer.location1FormInitialState,
            location2: inventoryCircuitReducer.location2FormInitialState,
            accessInformation: inventoryCircuitAccessInformationReducer.accessInformationFormInitialState,
            pipInformation: inventoryCircuitPIPInformationReducer.pipInformationFormInitialState
        }
        , inventoryCicuitPlanDetailsForm: inventoryCircuitPlanDetailsReducer.planDetailsFormInitialState
        , inventoryCircuitSIMForm: inventoryCircuitSIMReducer.circuitSimFormInitialState
        , inventoryCircuitEquipForm: inventoryCircuitEquipReducer.circuitEquipFormInitialState
        , inventoryCircuitCostAllocationForm: inventoryCostAllocationReducer.circuitCostAllocationFormInitialState
        , inventoryEquipmentForm: inventoryEquipmentReducer.equipmentInitialState
        , invoiceDisputeDetailsForm: invoiceDisputeDetailseReducer.disputeDetailsFormInitialState
        , invoiceDisputeFollowUpForm: invoiceDisputeFollowUpReducer.disputeFollowUpFormInitialState
        , invoiceInvoiceDetailsForm: invoiceInvoiceDetailsReducer.invoiceDetailsFormInitialState

        //Invoice
        ,invoiceUploadForm: invoiceUploadReducer.invoideUpdateFormInitialState
        ,chargeMappingForm: chargeMappingReducer.chargeMappingFormInitialState
    })
});

export default rootReducer;
